import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";

function Solutions() {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="hero-section-alt bg-gradient-primary text-white py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <h1 className="display-4 fw-bold mb-4">
                Built for People Who Actually Do the Work
              </h1>
              <p className="lead mb-0">
                Whether you're managing a CRP program, coaching consumers in the
                field, or trying to keep customers happy - this system actually
                works the way you work.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* For Vendor Admins */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center mb-5">
            <div className="col-lg-6">
              <div className="admin-pain bg-light rounded-3 p-4 mb-4">
                <h3 className="text-danger mb-3">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  Your Current Reality as a CRP Admin
                </h3>
                <p className="mb-3">
                  You're drowning. Managing multiple job coaches, dozens of
                  consumers, and constant pressure from customers who want to
                  know exactly what they're paying for.
                </p>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    😤 Job coaches submit handwritten logs you have to decipher
                    and retype
                  </li>
                  <li className="mb-2">
                    ⏰ Monthly reports take DAYS to compile from scattered
                    information
                  </li>
                  <li className="mb-2">
                    😰 You're constantly worried about exceeding authorized
                    hours
                  </li>
                  <li className="mb-2">
                    📊 Billing documentation is a nightmare of spreadsheets
                  </li>
                  <li className="mb-2">
                    ❓ Customers ask questions you can't answer without digging
                    through files
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <h2 className="fw-bold mb-4">
                Transform Into a Professional Operation
              </h2>
              <p className="lead mb-4">
                Stop competing on price alone. Compete on results, transparency,
                and operational excellence.
              </p>

              <div className="solution-benefits">
                <div className="benefit-item d-flex align-items-start mb-3">
                  <div className="benefit-icon bg-success bg-opacity-10 rounded-circle p-2 me-3">
                    <i className="bi bi-check-circle-fill text-success"></i>
                  </div>
                  <div>
                    <h6 className="fw-semibold mb-1">
                      Complete Organizational Control
                    </h6>
                    <small className="text-muted">
                      See all consumers, job coaches, and progress in one
                      dashboard. Know what's happening in real-time.
                    </small>
                  </div>
                </div>

                <div className="benefit-item d-flex align-items-start mb-3">
                  <div className="benefit-icon bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                    <i className="bi bi-file-earmark-check text-primary"></i>
                  </div>
                  <div>
                    <h6 className="fw-semibold mb-1">
                      Professional Documentation
                    </h6>
                    <small className="text-muted">
                      Mobile data entry means clean, professional reports that
                      impress customers.
                    </small>
                  </div>
                </div>

                <div className="benefit-item d-flex align-items-start mb-3">
                  <div className="benefit-icon bg-warning bg-opacity-10 rounded-circle p-2 me-3">
                    <i className="bi bi-currency-dollar text-warning"></i>
                  </div>
                  <div>
                    <h6 className="fw-semibold mb-1">Financial Control</h6>
                    <small className="text-muted">
                      Generate supporting documentation for invoices in minutes,
                      not hours. Get paid faster with professional
                      documentation.
                    </small>
                  </div>
                </div>

                <div className="benefit-item d-flex align-items-start">
                  <div className="benefit-icon bg-info bg-opacity-10 rounded-circle p-2 me-3">
                    <i className="bi bi-handshake text-info"></i>
                  </div>
                  <div>
                    <h6 className="fw-semibold mb-1">Customer Relationships</h6>
                    <small className="text-muted">
                      Become the vendor that customers prefer. Transparency
                      builds trust and renewals.
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* For Job Coaches */}
      <section className="py-5 bg-gradient-light">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-2">
              <div className="coach-pain bg-white rounded-3 p-4 mb-4 shadow-sm">
                <h3 className="text-danger mb-3">
                  <i className="bi bi-emoji-frown me-2"></i>
                  Your Reality as a Job Coach
                </h3>
                <p className="mb-3">
                  You're in the field helping consumers succeed, but paperwork
                  is killing your productivity.
                </p>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    📋 Carrying clipboards and losing handwritten notes
                  </li>
                  <li className="mb-2">
                    🤔 Trying to remember what happened at each consumer visit
                  </li>
                  <li className="mb-2">
                    🌙 Spending evenings doing paperwork instead of planning
                  </li>
                  <li className="mb-2">
                    😟 Worried about getting hours wrong and causing billing
                    problems
                  </li>
                  <li className="mb-2">
                    📝 Feeling like paperwork takes more time than helping
                    people
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 order-lg-1">
              <h2 className="fw-bold mb-4">
                Finally, Technology That Actually Helps
              </h2>
              <p className="lead mb-4">
                Document services in under 2 minutes, right from your phone. No
                more evening paperwork.
              </p>

              <div className="coach-solutions">
                <div className="solution-item d-flex align-items-start mb-3">
                  <div className="solution-icon bg-success bg-opacity-10 rounded-circle p-2 me-3">
                    <i className="bi bi-phone text-success"></i>
                  </div>
                  <div>
                    <h6 className="fw-semibold mb-1">Mobile-First Design</h6>
                    <small className="text-muted">
                      Log services while you're still with the consumer. Works
                      offline when cell service is spotty.
                    </small>
                  </div>
                </div>

                <div className="solution-item d-flex align-items-start mb-3">
                  <div className="solution-icon bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                    <i className="bi bi-clock text-primary"></i>
                  </div>
                  <div>
                    <h6 className="fw-semibold mb-1">No More Double Work</h6>
                    <small className="text-muted">
                      Enter it once, use it everywhere. Your daily logs
                      automatically become monthly reports.
                    </small>
                  </div>
                </div>

                <div className="solution-item d-flex align-items-start mb-3">
                  <div className="solution-icon bg-warning bg-opacity-10 rounded-circle p-2 me-3">
                    <i className="bi bi-shield-check text-warning"></i>
                  </div>
                  <div>
                    <h6 className="fw-semibold mb-1">Peace of Mind</h6>
                    <small className="text-muted">
                      The app tells you what information is needed. Never worry
                      about missing documentation.
                    </small>
                  </div>
                </div>
              </div>

              {/* <blockquote className="blockquote border-start border-success border-4 ps-3 mt-4">
                <p className="mb-2">
                  "I used to spend my evenings doing paperwork. Now I spend them
                  planning better ways to help my consumers succeed."
                </p>
                <footer className="blockquote-footer">
                  Job Coach using WebVenly
                </footer>
              </blockquote> */}
            </div>
          </div>
        </div>
      </section>

      {/* Day in the Life Comparison */}
      <section className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold mb-3">How It Changes Your Day</h2>
            <p className="lead text-muted">See the difference for yourself</p>
          </div>

          <div className="row g-4">
            <div className="col-lg-6">
              <div className="day-comparison bg-danger bg-opacity-10 rounded-3 p-4 h-100">
                <h4 className="text-danger mb-4">
                  <i className="bi bi-x-circle me-2"></i>
                  Before WebVenly
                </h4>
                <div className="timeline-day">
                  <div className="time-entry d-flex mb-3">
                    <div className="time-badge bg-danger text-white px-2 py-1 rounded me-3">
                      8:00 AM
                    </div>
                    <div className="time-desc">
                      Spend 15 minutes finding yesterday's notes to plan today
                    </div>
                  </div>
                  <div className="time-entry d-flex mb-3">
                    <div className="time-badge bg-danger text-white px-2 py-1 rounded me-3">
                      10:00 AM
                    </div>
                    <div className="time-desc">
                      Work with Consumer A, scribble notes on paper
                    </div>
                  </div>
                  <div className="time-entry d-flex mb-3">
                    <div className="time-badge bg-danger text-white px-2 py-1 rounded me-3">
                      12:00 PM
                    </div>
                    <div className="time-desc">
                      Work with Consumer B, lose the notes from Consumer A
                    </div>
                  </div>
                  <div className="time-entry d-flex mb-3">
                    <div className="time-badge bg-danger text-white px-2 py-1 rounded me-3">
                      2:00 PM
                    </div>
                    <div className="time-desc">
                      Work with Consumer C, can't remember what you did with
                      Consumer B
                    </div>
                  </div>
                  <div className="time-entry d-flex">
                    <div className="time-badge bg-danger text-white px-2 py-1 rounded me-3">
                      6:00 PM
                    </div>
                    <div className="time-desc fw-bold">
                      Spend 2 hours trying to recreate the day's activities 😫
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="day-comparison bg-success bg-opacity-10 rounded-3 p-4 h-100">
                <h4 className="text-success mb-4">
                  <i className="bi bi-check-circle me-2"></i>
                  With WebVenly
                </h4>
                <div className="timeline-day">
                  <div className="time-entry d-flex mb-3">
                    <div className="time-badge bg-success text-white px-2 py-1 rounded me-3">
                      8:00 AM
                    </div>
                    <div className="time-desc">
                      Review today's schedule and consumer progress on your
                      phone
                    </div>
                  </div>
                  <div className="time-entry d-flex mb-3">
                    <div className="time-badge bg-success text-white px-2 py-1 rounded me-3">
                      10:00 AM
                    </div>
                    <div className="time-desc">
                      Work with Consumer A, log session in 90 seconds before
                      leaving
                    </div>
                  </div>
                  <div className="time-entry d-flex mb-3">
                    <div className="time-badge bg-success text-white px-2 py-1 rounded me-3">
                      12:00 PM
                    </div>
                    <div className="time-desc">
                      Work with Consumer B, quick documentation captures
                      everything
                    </div>
                  </div>
                  <div className="time-entry d-flex mb-3">
                    <div className="time-badge bg-success text-white px-2 py-1 rounded me-3">
                      2:00 PM
                    </div>
                    <div className="time-desc">
                      Work with Consumer C, see their complete history to build
                      on previous work
                    </div>
                  </div>
                  <div className="time-entry d-flex">
                    <div className="time-badge bg-success text-white px-2 py-1 rounded me-3">
                      5:00 PM
                    </div>
                    <div className="time-desc fw-bold">
                      Day complete, all documentation done, evening free! 🎉
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ROI Breakdown */}
      <section className="py-5 bg-gradient-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold mb-3">
              What This Actually Means for Your Business
            </h2>
            <p className="lead text-muted">Real numbers, real results</p>
          </div>

          <div className="row g-4">
            <div className="col-lg-4">
              <div className="roi-benefit bg-white rounded-3 p-4 shadow-hover h-100 text-center">
                <div
                  className="roi-icon bg-primary bg-opacity-10 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{ width: "80px", height: "80px" }}
                >
                  <i className="bi bi-clock-history text-primary fs-2"></i>
                </div>
                <h4 className="fw-bold mb-3">Save 20+ Hours Monthly</h4>
                <p className="text-muted mb-3">
                  No more spending days compiling monthly reports. What used to
                  take 24 hours now takes 2.
                </p>
                <div className="roi-calculation bg-light rounded p-3">
                  <small className="text-muted">
                    20 hours × $25/hour ={" "}
                    <strong className="text-primary">$500/month saved</strong>
                  </small>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="roi-benefit bg-white rounded-3 p-4 shadow-hover h-100 text-center">
                <div
                  className="roi-icon bg-success bg-opacity-10 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{ width: "80px", height: "80px" }}
                >
                  <i className="bi bi-cash-stack text-success fs-2"></i>
                </div>
                <h4 className="fw-bold mb-3">Faster Payment Cycles</h4>
                <p className="text-muted mb-3">
                  Professional looking documentation so you can gets paid 2-3
                  weeks faster.
                </p>
                <div className="roi-calculation bg-light rounded p-3">
                  <small className="text-muted">
                    Better cash flow ={" "}
                    <strong className="text-success">
                      Improved operations
                    </strong>
                  </small>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="roi-benefit bg-white rounded-3 p-4 shadow-hover h-100 text-center">
                <div
                  className="roi-icon bg-warning bg-opacity-10 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{ width: "80px", height: "80px" }}
                >
                  <i className="bi bi-trophy text-warning fs-2"></i>
                </div>
                <h4 className="fw-bold mb-3">Contract Renewals</h4>
                <p className="text-muted mb-3">
                  When renewal time comes, you have comprehensive proof of
                  success and value delivered.
                </p>
                <div className="roi-calculation bg-light rounded p-3">
                  <small className="text-muted">
                    Professional operations ={" "}
                    <strong className="text-warning">Automatic renewals</strong>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Customers Section */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <h2 className="fw-bold mb-4">
                Customers Will Love Working With You
              </h2>
              <p className="lead mb-4">
                Stop being the vendor they have to chase for information. Become
                the vendor they showcase as an example.
              </p>

              <div className="state-benefits">
                <div className="benefit-card bg-light rounded-3 p-3 mb-3">
                  <h6 className="fw-semibold mb-2">
                    <i className="bi bi-eye text-primary me-2"></i>
                    Complete Transparency
                  </h6>
                  <p className="mb-0 small">
                    They can see exactly how their funds are being spent, in
                    real-time. No more awkward "where's my money going?"
                    conversations.
                  </p>
                </div>

                <div className="benefit-card bg-light rounded-3 p-3 mb-3">
                  <h6 className="fw-semibold mb-2">
                    <i className="bi bi-calendar-check text-success me-2"></i>
                    Reports Delivered On Time
                  </h6>
                  <p className="mb-0 small">
                    Professional reports, delivered consistently, in the format
                    they expect. No more chasing you for missing paperwork.
                  </p>
                </div>

                <div className="benefit-card bg-light rounded-3 p-3">
                  <h6 className="fw-semibold mb-2">
                    <i className="bi bi-graph-up text-warning me-2"></i>
                    Proven Results
                  </h6>
                  <p className="mb-0 small">
                    Show concrete consumer progress with data and documentation.
                    They can confidently justify funding your program.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom Line */}
      <section className="py-5 bg-gradient-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h2 className="display-5 fw-bold mb-4">The Bottom Line</h2>
              <p className="lead mb-5">
                This platform transforms you from a struggling service provider
                into a professional rehabilitation organization that customers
                want to work with.
              </p>
              <div className="row g-4">
                <div className="col-md-4">
                  <div className="bottom-benefit bg-white rounded-3 p-4 shadow-sm h-100">
                    <div
                      className="benefit-icon bg-primary bg-opacity-10 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{ width: "80px", height: "80px" }}
                    >
                      <i className="bi bi-people text-primary fs-2"></i>
                    </div>
                    <h5 className="fw-bold mb-2">Happy Job Coaches</h5>
                    <p className="text-muted mb-0">No more evening paperwork</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="bottom-benefit bg-white rounded-3 p-4 shadow-sm h-100">
                    <div
                      className="benefit-icon bg-success bg-opacity-10 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{ width: "80px", height: "80px" }}
                    >
                      <i className="bi bi-star text-success fs-2"></i>
                    </div>
                    <h5 className="fw-bold mb-2">Impressed Customers</h5>
                    <p className="text-muted mb-0">
                      Professional operations they trust
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="bottom-benefit bg-white rounded-3 p-4 shadow-sm h-100">
                    <div
                      className="benefit-icon bg-warning bg-opacity-10 rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                      style={{ width: "80px", height: "80px" }}
                    >
                      <i className="bi bi-graph-up text-warning fs-2"></i>
                    </div>
                    <h5 className="fw-bold mb-2">Growing Business</h5>
                    <p className="text-muted mb-0">
                      Scale without administrative chaos
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section bg-gradient-primary text-white py-5">
        <div className="container text-center">
          <h2 className="display-5 fw-bold mb-3">Stop Fighting the System</h2>
          <p className="lead mb-4">
            Your customers want to work with vendors who have their act
            together. This platform proves you do.
          </p>
          <div className="cta-buttons">
            <Link to="/demo" className="btn btn-light btn-lg me-3">
              <i className="bi bi-play-circle me-2"></i>
              See How It Works
            </Link>
            <Link to="/contact" className="btn btn-outline-light btn-lg">
              <i className="bi bi-chat-dots me-2"></i>
              Talk to Someone Who Gets It
            </Link>
          </div>
          <p className="mt-4 mb-0 text-white-75">
            <small>
              No sales pressure • Real solutions for real problems • Built by
              people who understand CRP work
            </small>
          </p>
        </div>
      </section>
    </Layout>
  );
}

export default Solutions;
